import { render, staticRenderFns } from "./InputCodeNdcList.vue?vue&type=template&id=95185bae&"
import script from "./InputCodeNdcList.vue?vue&type=script&lang=ts&"
export * from "./InputCodeNdcList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports